'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = destroyInstance;

var _getComponentFromElement = require('./getComponentFromElement');

var _getComponentFromElement2 = _interopRequireDefault(_getComponentFromElement);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Destroys and removes instance from DOM element
 * @param element: DOM element
 */

function destroyInstance(element) {
    var instance = (0, _getComponentFromElement2.default)(element);
    if (instance) {
        var name = instance._name;
        instance.unmount();
        element['__gia_component__'] = null;
        if (_config2.default.get('log')) {
            console.info('Removed component "' + name + '".');
        }
    }
}
